import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useExperienceWizard } from 'core/contexts/experienceWizard';
import { Box, Button, Fade, Grid2, Zoom } from '@mui/material';
import { CheckOutlined } from '@mui/icons-material';
import Title from 'modules/Pricing/components/Title';

const SuccessPage = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const translate = (key) => t(`experience_wizard.success_page.${key}`);
    const { isSuccess, setIsSuccess, resetWizard, newExperienceId, setNewExperienceId } = useExperienceWizard();

    const buttonStyle = {
        width: '100%',
        py: '8px',
        borderRadius: '8px',
        textTransform: 'none',
    };

    const navigate = (route) => {
        history.push(route);
        resetWizard();
        setIsSuccess(false);
        setNewExperienceId(null);
    };

    return (
        <Zoom in={isSuccess} timeout={500}>
            <Fade in={isSuccess} timeout={800}>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '80dvh', textAlign: 'center', gap: 2, maxWidth: '500px', padding: '24px', justifySelf: 'center' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 64, height: 64, borderRadius: '100%', backgroundColor: '#50C878', boxShadow: '0px 0px 0px 8px #50C87840' }}>
                        <CheckOutlined sx={{ fontSize: 40, color: '#fff' }} />
                    </Box>
                    <Title title={translate('title')} description={translate('description')} align="center" />

                    <Grid2 container direction="column" width="100%" justifyContent="center" alignItems="center" gap="8px" mt="16px">
                        <Button
                            variant="contained"
                            sx={{
                                ...buttonStyle,
                                backgroundColor: 'var(--color-utriper-blue)',
                            }}
                            onClick={() => {
                                resetWizard();
                                setIsSuccess(false);
                            }}
                        >
                            {translate('add_button')}
                        </Button>
                        <Grid2 container flexWrap="nowrap" width="100%" gap="16px">
                            <Button
                                variant="outlined"
                                sx={{
                                    ...buttonStyle,
                                    border: 'solid 1px #13131340',
                                    color: '#131313',
                                }}
                                onClick={() => navigate('/home')}
                            >
                                {translate('dashboard_button')}
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    ...buttonStyle,
                                    backgroundColor: 'var(--color-utriper-blue)',
                                }}
                                onClick={() => navigate(`/experience/${newExperienceId}`)}
                            >
                                {translate('details_button')}
                            </Button>
                        </Grid2>
                    </Grid2>
                </Box>
            </Fade>
        </Zoom>
    );
};

export default SuccessPage;
